import React from "react";
import { facebookIcon2, instagramIcon2, twitterIcon2 } from "../assets";

const SocialHero = () => {
  return (
    <div className="absolute hidden md:flex flex-col gap-6 left-8 top-[250px]">
      <a href="https://www.tiktok.com/@wosamhotels" target="_blank">
        <img src={twitterIcon2} alt="" className="w-3 cursor-pointer" />
      </a>
      <a href="https://www.instagram.com/wosamarena/" target="_blank">
        <img src={instagramIcon2} alt="" className="w-3 cursor-pointer" />
      </a>
      <a href="https://web.facebook.com/WosamArena/" target="_blank">
        <img src={facebookIcon2} alt="" className="w-3 cursor-pointer" />
      </a>
    </div>
  );
};

export default SocialHero;
